var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{class:`message ${_vm.type || 'neutral'}`},[_c('Icon',{attrs:{"name":_vm.switchIcon,"size":"20px"}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }